export const Messages = {
  lastCheck: 'Last check: ',
};
